// deadline_pattern
export const DEADLINE_PATTERN_DISPLAY_DUE_DATE = 1;
